import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';

const isProduction = process.env.NODE_ENV === 'production';

// Only initialize i18next if it hasn't been initialized yet
// This prevents re-initialization during hot reloads in development
if (!i18next.isInitialized) {
  i18next
    .use(HttpBackend)
    .use(initReactI18next)
    .init({
      // Core configuration
      lng: 'en', // Default language
      fallbackLng: 'en',

      // Supported languages
      supportedLngs: ['en', 'es'],

      // Namespace configuration
      defaultNS: 'common',
      ns: ['common'],

      // Backend configuration for loading translations
      backend: {
        loadPath: '/locales/{{lng}}/{{ns}}.json',
      },

      // React-specific options
      react: {
        useSuspense: false, // Disable suspense to avoid hydration issues in Remix
      },

      // Debug in development
      debug: !isProduction,

      // Interpolation options
      interpolation: {
        escapeValue: false, // React already escapes values
      },

      // Loading and error handling
      saveMissing: !isProduction, // Log missing keys in development
      missingKeyHandler: !isProduction
        ? (lng, ns, key) => console.warn(`Missing translation key: ${key} for ${lng}/${ns}`)
        : undefined,
    });
}

export default i18next;